export var MODE_OPTIONS = {
    label: 'Mode',
    id: 'mode',
    settings: [
        {
            label: 'Grouped',
            isActive: function (_a) {
                var groupMode = _a.groupMode;
                return groupMode === 'grouped';
            },
            defaultValue: {
                groupMode: 'grouped',
                stackMode: undefined,
            },
        },
        {
            label: 'Stacked Normal',
            isActive: function (_a) {
                var groupMode = _a.groupMode, stackMode = _a.stackMode;
                return groupMode === 'stacked' && stackMode === 'normal';
            },
            defaultValue: {
                groupMode: 'stacked',
                stackMode: 'normal',
            },
        },
        {
            label: 'Stacked %',
            isActive: function (_a) {
                var groupMode = _a.groupMode, stackMode = _a.stackMode;
                return groupMode === 'stacked' && stackMode === 'percent';
            },
            defaultValue: {
                groupMode: 'stacked',
                stackMode: 'percent',
            },
        },
    ],
};
export var METRIC_TYPE_OPTIONS = {
    label: 'Type',
    id: 'metric-type',
    settings: [
        {
            label: 'Simple',
            isActive: function (_a) {
                var type = _a.type;
                return type === 'simple';
            },
            defaultValue: {
                type: 'simple',
                usePercentDifference: false,
            },
        },
        {
            label: 'Comparison',
            isActive: function (_a) {
                var type = _a.type;
                return type === 'comparison';
            },
            defaultValue: {
                type: 'comparison',
                usePercentDifference: false,
            },
        },
        {
            label: 'Difference',
            isActive: function (_a) {
                var type = _a.type, usePercentDifference = _a.usePercentDifference;
                return type === 'difference' && !usePercentDifference;
            },
            defaultValue: {
                type: 'difference',
                usePercentDifference: false,
            },
        },
        {
            label: 'Difference %',
            isActive: function (_a) {
                var type = _a.type, usePercentDifference = _a.usePercentDifference;
                return type === 'difference' && usePercentDifference;
            },
            defaultValue: {
                type: 'difference',
                usePercentDifference: true,
            },
        },
    ],
};
export var LINE_CURVE_OPTIONS = {
    label: 'Shape',
    id: 'line-shape',
    settings: [
        {
            label: 'Line',
            isActive: function (_a) {
                var curve = _a.curve;
                return curve === 'linear';
            },
            defaultValue: {
                curve: 'linear',
            },
        },
        {
            label: 'Spline',
            isActive: function (_a) {
                var curve = _a.curve;
                return curve === 'spline';
            },
            defaultValue: {
                curve: 'spline',
            },
        },
        {
            label: 'Steps',
            isActive: function (_a) {
                var curve = _a.curve;
                return curve === 'step';
            },
            defaultValue: {
                curve: 'step',
            },
        },
    ],
};
export var GEOGRAPHIC_AREA_OPTIONS = {
    label: 'Map',
    id: 'geographic-area',
    settings: [
        {
            label: 'World',
            isActive: function (_a) {
                var geographicArea = _a.geographicArea;
                return geographicArea === 'world';
            },
            defaultValue: {
                geographicArea: 'world',
            },
        },
        {
            label: 'United States',
            isActive: function (_a) {
                var geographicArea = _a.geographicArea;
                return geographicArea === 'us';
            },
            defaultValue: {
                geographicArea: 'us',
            },
        },
    ],
};
export var GAUGE_CHART_OPTIONS = {
    label: 'Type',
    id: 'gauge-type',
    settings: [
        {
            label: 'Normal',
            isActive: function (_a) {
                var progressType = _a.progressType;
                return progressType === 'normal';
            },
            defaultValue: {
                progressType: 'normal',
            },
        },
        {
            label: 'Percent',
            isActive: function (_a) {
                var progressType = _a.progressType;
                return progressType === 'percent';
            },
            defaultValue: {
                progressType: 'percent',
            },
        },
    ],
};
export var WIDGETS = [
    {
        id: 'table',
        icon: 'table-widget',
        widget: 'table',
        isActive: function (widget) { return widget === 'table'; },
        defaultChartSettings: {},
        defaultWidgetSettings: {},
    },
    {
        id: 'json',
        icon: 'json',
        widget: 'json',
        isActive: function (widget) { return widget === 'json'; },
        defaultChartSettings: {},
        defaultWidgetSettings: {},
    },
    {
        id: 'metric',
        icon: 'metric-widget',
        widget: 'metric',
        chartOptions: [METRIC_TYPE_OPTIONS],
        isActive: function (widget) { return widget === 'metric'; },
        defaultChartSettings: {
            type: 'simple',
        },
        defaultWidgetSettings: {},
    },
    {
        id: 'bar',
        icon: 'bar-widget-vertical',
        widget: 'bar',
        chartOptions: [MODE_OPTIONS],
        isActive: function (widget, _a) {
            var layout = _a.layout;
            return widget === 'bar' && layout === 'vertical';
        },
        defaultChartSettings: {
            layout: 'vertical',
            groupMode: 'grouped',
        },
        defaultWidgetSettings: {},
    },
    {
        id: 'bar',
        icon: 'bar-widget-horizontal',
        widget: 'bar',
        chartOptions: [MODE_OPTIONS],
        isActive: function (widget, _a) {
            var layout = _a.layout;
            return widget === 'bar' && layout === 'horizontal';
        },
        defaultChartSettings: {
            layout: 'horizontal',
            groupMode: 'grouped',
        },
        defaultWidgetSettings: {},
    },
    {
        id: 'donut',
        icon: 'donut-widget',
        widget: 'donut',
        isActive: function (widget) { return widget === 'donut'; },
        defaultChartSettings: {},
        defaultWidgetSettings: {},
    },
    {
        id: 'pie',
        icon: 'pie-widget',
        widget: 'pie',
        isActive: function (widget) { return widget === 'pie'; },
        defaultChartSettings: {},
        defaultWidgetSettings: {},
    },
    {
        id: 'line',
        icon: 'line-widget',
        widget: 'line',
        chartOptions: [LINE_CURVE_OPTIONS, MODE_OPTIONS],
        isActive: function (widget) { return widget === 'line'; },
        defaultChartSettings: {
            curve: 'linear',
            areaMode: false,
            stackMode: 'normal',
            groupMode: 'grouped',
        },
        defaultWidgetSettings: {},
    },
    {
        id: 'area',
        icon: 'area-widget',
        widget: 'area',
        chartOptions: [LINE_CURVE_OPTIONS, MODE_OPTIONS],
        isActive: function (widget) { return widget === 'area'; },
        defaultChartSettings: {
            curve: 'linear',
            stackMode: 'normal',
            groupMode: 'grouped',
        },
        defaultWidgetSettings: {},
    },
    {
        id: 'funnel',
        icon: 'funnel-widget-vertical',
        widget: 'funnel',
        isActive: function (widget, _a) {
            var layout = _a.layout;
            return widget === 'funnel' && layout === 'vertical';
        },
        defaultChartSettings: {
            layout: 'vertical',
        },
        defaultWidgetSettings: {},
    },
    {
        id: 'funnel',
        icon: 'funnel-widget-horizontal',
        widget: 'funnel',
        isActive: function (widget, _a) {
            var layout = _a.layout;
            return widget === 'funnel' && layout === 'horizontal';
        },
        defaultChartSettings: {
            layout: 'horizontal',
        },
        defaultWidgetSettings: {},
    },
    {
        id: 'heatmap',
        icon: 'heatmap-widget',
        widget: 'heatmap',
        isActive: function (widget) { return widget === 'heatmap'; },
        defaultChartSettings: {},
        defaultWidgetSettings: {},
    },
    {
        id: 'choropleth',
        icon: 'choropleth-widget',
        widget: 'choropleth',
        widgetOptions: [GEOGRAPHIC_AREA_OPTIONS],
        isActive: function (widget) { return widget === 'choropleth'; },
        defaultChartSettings: {},
        defaultWidgetSettings: {
            geographicArea: 'world',
        },
    },
    {
        id: 'gauge',
        icon: 'gauge-widget',
        widget: 'gauge',
        chartOptions: [GAUGE_CHART_OPTIONS],
        isActive: function (widget) { return widget === 'gauge'; },
        defaultChartSettings: {
            progressType: 'normal',
        },
        defaultWidgetSettings: {},
    },
];
